export enum ESituacaoBoleto {
    NaoEmitido = 1,
    Emitido = 2,
    Registrado = 3,
    Negativado = 4,
    Baixado = 5,
    Protestado = 6,
    DescontoRequisitado = 7,
    DescontoEfetivado = 8,
}
